<template>
  <section>
    <section class="navBack">
      <v-container class="container-custom">
        <v-row>
          <v-col md="12" class="topNav">
            <ul class="navList">
              <li>Home</li>
              <li><v-icon> mdi-chevron-right </v-icon> My Address</li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="my-5 mb-15">
      <v-container class="container-custom">
        <v-row>
          <v-col md="3">
            <Navigation />
          </v-col>
          <v-col md="9" cols="12">
            <div class="d-flex justify-space-between">
              <h2 class="mb-5">My Address</h2>
              <router-link to="/addAddress">
                <v-btn> Add Address </v-btn></router-link
              >
            </div>

            <div class="filterationBox">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr class="greenBack">
                      <th class="text-left">Fullname</th>
                      <th class="text-left">Address</th>
                      <th class="text-left">Phone 1</th>
                      <th class="text-left">Phone 2</th>
                      <th class="text-left">Address Type</th>
                      <th class="text-left">Default</th>
                      <th class="text-left" colspan="2">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="!loading">
                    <tr
                      v-for="(item, index) in addresses"
                      :key="index + `address`"
                    >
                      <td>{{ item.fullname }}</td>
                      <td>{{ item.address }}</td>
                      <td>{{ item.phone1 }}</td>
                      <td>{{ item.phone2 }}</td>
                      <td class="text-capitalize">{{ item.addressType }}</td>
                      <td>
                        <v-progress-circular
                          indeterminate
                          size="20"
                          width="1"
                          v-if="selected == index && loadingSingle"
                        ></v-progress-circular>
                        <v-switch
                          v-if="selected != index || !loadingSingle"
                          v-model="item.default"
                          @change="defaultAction(item._id, index)"
                        ></v-switch>
                      </td>
                      <td>
                        <router-link :to="`addAddress/${item._id}`"
                          ><v-icon>
                            mdi-square-edit-outline
                          </v-icon></router-link
                        >
                      </td>
                      <td>
                        <v-icon @click="removeAddress(item._id)">
                          mdi-delete
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="loading">
                    <tr>
                      <td>
                        Loading
                        <v-progress-circular
                          indeterminate
                          size="20"
                          width="1"
                        ></v-progress-circular>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="7">
                        <ul class="pagination">
                          <li><v-icon> mdi-chevron-left </v-icon></li>
                          <li>1 - 10 Items</li>
                          <li><v-icon> mdi-chevron-right </v-icon></li>
                        </ul>
                      </td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </section>
</template>

<script>
import Navigation from "@/components/user/Navigation";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Address",
  components: {
    Navigation,
  },
  data: () => ({
    limit: 10,
    page: 1,
    addresses: undefined,
    loading: true,
    loadingSingle: false,
    selected: undefined,
  }),
  methods: {
    ...mapActions(["getAddresses", "postAddress", "deleteAddress"]),
    async defaultAction(id, index) {
      this.loadingSingle = true;
      this.selected = index;
      await this.postAddress({ _id: id, default: true });
      await this.getAddresses({ limit: this.limit, page: this.page });
      this.addresses = this.allAddresses.results;
      this.loadingSingle = false;
    },
    async removeAddress(id) {
      await this.deleteAddress(id);
      this.addresses = this.allAddresses.results;
    },
  },
  computed: {
    ...mapGetters(["allAddresses"]),
  },
  async created() {
    await this.getAddresses({ limit: this.limit, page: this.page });
    this.addresses = this.allAddresses.results;
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";
.navBack {
  background: #f4f4f4;
  padding: 10px 0;
}
.navList {
  padding-left: 0;
  list-style: none;
  display: flex;
  font-size: 14px;
  li {
    .v-icon {
      font-size: 18px;
      margin-left: 5px;
    }
    // margin-right: 15px;
  }
}
.v-btn {
  min-height: 5 0px;
  width: 200px;
  color: #0878d4 !important;
  background: #fff !important;
  border: 1px solid #0878d4;
  box-shadow: none !important;
}
.filterationBox {
  border: 1px solid #efefef;
  padding: 20px 20px 10px;
  margin-bottom: 20px;
  header {
    display: flex;
    margin-bottom: 10px;
    justify-content: space-between;
    font-weight: 500;
  }
  .toogleBox {
    display: none;
  }
  .filterBox {
    padding-left: 0;
    margin-bottom: 0;
    margin-top: 15px;
    li {
      font-size: 14px;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      a {
        text-decoration: none;
        color: #000;
      }
    }
  }
  .detailList {
    padding-left: 0;
    margin-bottom: 10px;
    li {
      color: #8c8c8c;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      .v-icon {
        margin-left: 10px;
        font-size: 20px;
      }
    }
  }
}
.v-input {
  margin-top: 0 !important;
}
a {
  text-decoration: none;
}
p {
  margin-bottom: 3px;
}
.orders {
  display: flex;
  padding-left: 0;
  list-style: none;
  flex-wrap: wrap;
  margin: 0 -15px;
  li {
    width: 50%;
    padding: 15px;
    .offerCard {
      box-shadow: 0 3px 5px #f2eeee;
      padding: 15px;
      display: flex;
      justify-content: flex-start;
      .image {
        width: 150px;
        height: 150px;
        background: #f4f4f4;
        img {
          object-fit: contain;
          width: 150px;
          height: 150px;
          border-radius: 10px;
        }
        margin-right: 10px;
      }
      .offerDescription {
        width: 75%;
        padding-left: 15px;
        .offerTitle {
          color: rgba(26, 26, 26, 1);
          font-weight: 600;
          font-size: 20px;
        }
        .price {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          p {
            font-size: 16px;
          }
        }
      }
    }
    .text-red {
      color: rgba(197, 46, 127, 1);
      font-weight: 700;
    }
    .text-yellow {
      color: #f9be27 !important;
      font-size: 18px;
    }
    .salePrice {
      position: relative;
      text-decoration: line-through;
      &::after {
        position: absolute;
        text-decoration: none;
      }
    }
  }
}

.pagination {
  list-style: none;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .v-icon {
    font-size: 18px;
    height: 30px;
    width: 30px;
    display: flex;
  }
}
</style>